<template>
  <div class="feedback-setting-page">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <component :is="tab"></component>
    </transition>
  </div>
</template>

<script>
import tabHeader from "@/components/tabHeader";
import msg from "./msg";
import keyWord from "./keyWord";
export default {
  components: {
    msg,
    keyWord,
    tabHeader
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: "收到消息回复",
          component: "msg"
        },
        {
          name: "关键词回复",
          component: "keyWord"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: "msg"
    };
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.feedback-setting-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
